import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import {
  COLOR_GREY_2,
  COLOR_GREY_5,
  COLOR_GREY_7,
  COLOR_GREY_9,
  COLOR_PRIMARY_MAIN,
} from "shared/theme/colors";

export const StyledContainer = styled.div`
  max-height: 382px;
  overflow: auto;
  margin-bottom: 48px;
`;

export const StyledCollapseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 32px;
  padding: 0 12px;
  cursor: pointer;

  &:hover {
    background-color: ${COLOR_GREY_5}10;
  }
`;

export const StyledCollapseContent = styled.div`
  padding: 0 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledIconWrapper = styled(Box, {
  shouldForwardProp: (propName) => !["isOpen"].includes(propName),
})<{ isOpen: boolean }>`
  display: flex;
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease-in-out;
`;

export const StyledCheckbox = styled(Checkbox)`
  color: ${COLOR_GREY_7};
  padding: 0 12px 0 0;

  &.Mui-checked {
    color: ${COLOR_PRIMARY_MAIN};
  }
`;

export const StyledCheckboxWrapper = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  height: 28px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: left;

  .MuiTouchRipple-root {
    left: -6px !important;
    top: -6px !important;
    height: 32px;
    width: 32px;
  }

  &:hover {
    background-color: ${COLOR_GREY_2};
  }
`;

export const StyledEmptyState = styled.div`
  display: flex;
  height: 100%;
  padding: 1rem 0.75rem;
  color: ${COLOR_GREY_9};
`;
